import { render, staticRenderFns } from "./empower.vue?vue&type=template&id=61965458&scoped=true"
import script from "./empower.vue?vue&type=script&lang=js"
export * from "./empower.vue?vue&type=script&lang=js"
import style0 from "./empower.vue?vue&type=style&index=0&id=61965458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61965458",
  null
  
)

export default component.exports